const fields = [
  // {
  //   dataIndex: 'id',
  //   key: 'id',
  //   title: '序号',
  //   width: 80,
  //   scopedSlots: {
  //     customRender: 'subscript'
  //   }
  // },
  {
    dataIndex: 'enpName',
    key: 'enpName',
    width: 100,
    title: '企业名称'
  },
  {
    dataIndex: 'statusStr',
    key: 'statusStr',
    width: 400,
    scopedSlots: {
      customRender: 'multipleRadio'
    },
    title: '专利数'
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 100,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 8,
    label: '监控单位',
    // component: 'ASelect',
    component: 'AInput',
    placeholder: '请输入监控单位名称',
    prop: 'condition',
    // list: [
    //   { label: '申请人', value: '申请人' },
    //   { label: '专利权人', value: '专利权人' },
    // ]
  },
  {
    span: 13,
    label: '检索式',
    component: 'AInput',
    prop: 'searchExpre',
    allowClear: true,
    placeholder: '请输入检索内容'
  },
  {
    span: 3,
    label: '',
    btName: '检索',
    component: 'OtherButton',
    cb: 'searchExp'
  }
]

const formRules = {
  condition: [{ required: true, message: '监控单位不能为空', trigger: 'blur' }],
  searchExpre: [{ required: true, message: '检索式不能为空', trigger: ['blur'] }],
}

const slotOpt = [
  {
    slot: 'action',
    component: 'Action',
     list: [ { name: '同步', cb: 'syncCompany' } ]
  },
  {
    slot: 'multipleRadio',
    component: 'MultipleRadio',
    cb: 'radioChange',
    radioList: [
      { label: '审查中', value: '0', prop: 'checkCount', status: 0 },
      { label: '有效', value: '0', prop: 'effectiveCount', status: 1 },
      { label: '失效', value: '0', prop: 'invalidCount', status: 2 }
    ]
  }
]


module.exports={
  fields,
  formRules,
  formRow,
  slotOpt
}
